var map = {
	"./create-card-hover.svg": 60,
	"./create-card.svg": 9521,
	"./start-verification-hover.svg": 3563,
	"./start-verification.svg": 2634,
	"./top-up-balance-hover.svg": 1265,
	"./top-up-balance.svg": 3084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7998;